export default __webpack_public_path__ + "59b96e13b900d76cbf98620df668878d.png";